/**
 Based on the Core MultiLanguage form without the language properties and creating the localisations array.
 BaseForm handles errors from GraphQL and injects into React Admin warning popups.
 Delete confirmation title and content message can be customize by adding dialogTitle and dialogContent string.
**/

import React, { useState } from 'react';
import {
  SimpleForm,
  useRefresh,
  useNotify,
  Notification,
  useRedirect,
} from 'react-admin';
import useDataProviderWrapper from '../../../hooks/dataProviderWrapper';
import { MultiLanguageToolbar } from '../../Toolbars';

const BaseForm = ({
  createRecord = {},
  undoable,
  customRedirect = false,
  showToolbar = true,
  ...props
}) => {
  const {
    children,
    resource,
    record,
    dialogTitle,
    dialogContent,
    iscompleted,
  } = props;

  const callToDataProvider = useDataProviderWrapper();
  const refresh = useRefresh();
  const redirect = useRedirect();
  const notify = useNotify();
  const [saving, setSaving] = useState(false);

  const handleSubmit = (data) => {
    try {
      setSaving(true);
      // Error: GraphQL error: Sorry an event with code 987654325 already exists!
      return callToDataProvider({
        type: record && record.id ? 'UPDATE' : 'CREATE',
        resource,
        payload: {
          id: data.id || null,
          data: {
            ...createRecord,
            ...data,
          },
        },
        onSuccess: (result) => {
          setSaving(false);
          if (props.match && !customRedirect) {
            redirect(`${props.match.url}`);
          } else if (customRedirect) {
            redirect(customRedirect);
          } else {
            refresh();
          }
        },
        onFailure: (error) => {
          setSaving(false);
          if (error.message.split(':')[0] == 'GraphQL error') {
            return notify(error.message.split(':')[1], 'warning');
          }
          return notify(error.message, 'warning');
        },
      });
    } catch (error) {
      return notify(
        error.message,
        'warning',
        error.payload,
        error.undoable,
        error.timeout
      );
    }
  };

  return (
    <>
      <SimpleForm
        {...props}
        redirect={false}
        save={handleSubmit}
        saving={saving}
        record={record}
        undoable={false}
        toolbar={
          showToolbar ? (
            <MultiLanguageToolbar
              iscompleted={iscompleted}
              dialogTitle={dialogTitle}
              dialogContent={dialogContent}
            />
          ) : null
        }
      >
        {children}
      </SimpleForm>
      <Notification />
    </>
  );
};

export default BaseForm;
